export default __webpack_public_path__ + "c63ded0cb1ffa6bef62e5e82a121c355.svg";